import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'
import AddressClaimModal from '../components/claim/AddressClaimModal'
import Header from '../components/Header'
import Polling from '../components/Header/Polling'
import URLWarning from '../components/Header/URLWarning'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import { ApplicationModal } from '../state/application/actions'
import { useModalOpen, useToggleModal } from '../state/application/hooks'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import AddLiquidity from './AddLiquidity'
import {
  RedirectDuplicateTokenIds,
  RedirectOldAddLiquidityPathStructure,
  RedirectToAddLiquidity
} from './AddLiquidity/redirects'
import Earn from './Earn'
import SingleStake from './SingleStake'
import NFTStake from './NFTStake'

import Manage from './Earn/Manage'
import SSManage from './SingleStake/SSManage'

import MigrateV1 from './MigrateV1'
import MigrateV1Exchange from './MigrateV1/MigrateV1Exchange'
import RemoveV1Exchange from './MigrateV1/RemoveV1Exchange'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
import RemoveLiquidity from './RemoveLiquidity'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import Swap from './Swap'
import { OpenClaimAddressModalAndRedirectToSwap, RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'
import MHUB from './MHUB'

import Vote from './Vote'
import VotePage from './Vote/VotePage'
import Footer from '../components/Footer'
import NFTStakeManage from './NFTStake/NFTStakeManage'
import IDO from './IDO'
import IDOManage from './IDO/IDOManage'
import LPBoostStakeManage from './Earn/LPBoostStakeManage'
import SSBoostStakeManage from './Earn/SSBoostStakeManage'
import img from '../assets/images/Galaxy1.jpg'
import Zapper from './Zapper'
import FormLP from './FormLP'
import xVault from './xVault'
import LPRewardsV2Manage from './RewardsV2/lpRewardsManage'
import SSRewardsV2Manage from './RewardsV2/ssRewardsManage'
import NFTStakeManageGangVerse from './NFTStake/NFTStakeManage_GangVerse'
import OtherLPBoostStakeManage from './Earn/OtherLPBoostStakeManage'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
`

const ImageDiv = styled.div`
background-image: url(${img});
  background-size: cover;
  background-position: right top;
  position: fixed;
  top: 0px;
  right: 0px;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  justify-content: space-between;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 100px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 10;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 16px;
    padding-top: 2rem;
  `};

  z-index: 1;
`

const Marginer = styled.div`
  margin-top: 5rem;
`

function TopLevelModals() {
  const open = useModalOpen(ApplicationModal.ADDRESS_CLAIM)
  const toggle = useToggleModal(ApplicationModal.ADDRESS_CLAIM)
  return <AddressClaimModal isOpen={open} onDismiss={toggle} />
}

export default function App() {
  return (
    <Suspense fallback={null}>
      <Route component={GoogleAnalyticsReporter} />
      <Route component={DarkModeQueryParamReader} />
      <ImageDiv />
      <AppWrapper>
        <Footer />
        <URLWarning />
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>
        <BodyWrapper>
          <Popups />
          <Polling />
          <TopLevelModals />
          <Web3ReactManager>
            <Switch>
              <Route exact strict path="/swap" component={Swap} />
              <Route exact strict path="/zapper" component={Zapper} />

              <Route exact strict path="/claim" component={OpenClaimAddressModalAndRedirectToSwap} />
              <Route exact strict path="/swap/:outputCurrency" component={RedirectToSwap} />
              <Route exact strict path="/send" component={RedirectPathToSwapOnly} />
              <Route exact strict path="/find" component={PoolFinder} />
              <Route exact strict path="/pool" component={Pool} />
              <Route exact strict path="/rewards/pair" component={Earn} />
              <Route exact strict path="/rewards/single" component={SingleStake} />
              <Route exact strict path="/rewards/nft" component={NFTStake} />
              <Route exact strict path="/xvault" component={xVault} />

              <Route exact strict path="/vote" component={Vote} />
              <Route exact strict path="/create" component={RedirectToAddLiquidity} />
              <Route exact path="/add" component={AddLiquidity} />
              <Route exact path="/formLP" component={FormLP} />

              <Route exact path="/add/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
              <Route exact path="/add/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
              <Route exact path="/create" component={AddLiquidity} />
              <Route exact path="/create/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
              <Route exact path="/create/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
              <Route exact strict path="/remove/v1/:address" component={RemoveV1Exchange} />
              <Route exact strict path="/remove/:tokens" component={RedirectOldRemoveLiquidityPathStructure} />
              <Route exact strict path="/remove/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />
              <Route exact strict path="/migrate/v1" component={MigrateV1} />
              <Route exact strict path="/migrate/v1/:address" component={MigrateV1Exchange} />
              <Route exact strict path="/rewards/pair/:rewardAddr" component={Manage} />
              <Route exact strict path="/rewards/single/:rewardAddr" component={SSManage} />
              <Route exact strict path="/rewards/nft/:rewardAddr" component={NFTStakeManage} />
              <Route exact strict path="/rewards/nft/custom1/:rewardAddr" component={NFTStakeManageGangVerse} />
              <Route exact strict path="/rewards/boost/pair/:rewardAddr" component={LPBoostStakeManage} />
              <Route exact strict path="/rewards/boost/single/:rewardAddr" component={SSBoostStakeManage} />
              <Route exact strict path="/rewards/boost/otherlp/:rewardAddr" component={OtherLPBoostStakeManage} />

              <Route exact strict path="/rewards/lp/:rewardAddr" component={LPRewardsV2Manage} />
              <Route exact strict path="/rewards/ss/:rewardAddr" component={SSRewardsV2Manage} />

              <Route exact strict path="/ido" component={IDO} />
              <Route exact strict path="/ido/:idoAddr" component={IDOManage} />

              <Route exact strict path="/vote/:id" component={VotePage} />
              <Route exact strict path="/mhub" component={MHUB} />
              <Route component={RedirectPathToSwapOnly} />
            </Switch>
          </Web3ReactManager>
          <Marginer />
        </BodyWrapper>
      </AppWrapper>
    </Suspense>
  )
}
